import { render, staticRenderFns } from "./PastelCover.vue?vue&type=template&id=4a79bdfb&scoped=true&"
import script from "./PastelCover.vue?vue&type=script&lang=ts&"
export * from "./PastelCover.vue?vue&type=script&lang=ts&"
import style0 from "./PastelCover.vue?vue&type=style&index=0&id=4a79bdfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79bdfb",
  null
  
)

export default component.exports